import { Button } from "antd";
import { useDispatch } from "react-redux";
import { setMceModal } from "states/global-value/global-value.slice";
import { ThemeTemplateItem } from "states/theme-template/theme-template.models";

export interface IThemeSettingTextHtmlProps {
  model: any;
  template: ThemeTemplateItem;
  onChange: (changedModel: any) => void;
}

export function ThemeSettingTextHtml(props: IThemeSettingTextHtmlProps) {
  const dispatch = useDispatch();
  const { model, template, onChange } = props;

  return (
    <div className="mt-2 mb-4">
      <div className="pb-2">
        <b>{template.name}</b>
      </div>
      {/* <div dangerouslySetInnerHTML={{ __html: model.value }}></div> */}
      <Button
        onClick={() => {
          dispatch(
            setMceModal({
              show: true,
              value: model?.value ?? "",
              onChange: (value) => {
                onChange({ ...model, value: value });
              },
            })
          );
        }}
        type="primary"
      >
        Update content
      </Button>
    </div>
  );
}
